import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchVinWiseOpening } from "../data/actions";
import * as select from "../data/selectors";
import { Grid, Button, Icon } from "semantic-ui-react";
import { heightSet } from "../../../utilities/heightSet";
import { searchColumns } from "../data/model";
import { TableListDiv } from "../../../utilities/tableListDiv";

const VinWiseOpeningList = (props) => {
    const dispatch = useDispatch();
    const vinWiseOpening = useSelector((state) =>
        select.getFilteredVinWiseOpening(state)
    );
    const [heights, setHeight] = useState("");
    
    useEffect(() => {
        dispatch(fetchVinWiseOpening());
    }, []);

    const callHeightFunc = () => {
        heightSet(setHeight);
    };

    useEffect(() => {
        callHeightFunc();
        window.addEventListener("resize", callHeightFunc, false);
        return () => {
            window.removeEventListener("resize", callHeightFunc);
        };
    }, []);

    const vinWiseOpeningAction = ({ object: obj }) => {
        return (
            <>
                <Link to={"/vin_wise_opp/edit/" + obj.vin} title="Edit">
                    <Icon name="edit" color="blue" link />
                </Link>
            </>
        );
    };
    const redirectToAddVinWiseOpening = () => {
        props.history.push({ pathname: "/vin_wise_opp/create" });
    };

    return (
        <>
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 4px 12px",
            }}>
                <div>
                    <div style={{ fontSize: "17px", fontWeight: 600, color: "#1f2d3d", lineHeight: 1.2 }}>
                        Vin Wise Opening
                    </div>
                    <div style={{ fontSize: "12px", color: "#8a96a8", marginTop: "2px" }}>
                        Manage VIN-wise opening balances.
                    </div>
                </div>
                <Button
                    onClick={redirectToAddVinWiseOpening}
                    type="button"
                    color="blue"
                    size="small"
                    icon
                    labelPosition="left"
                >
                    <Icon name="plus" />
                    Add Vin Wise Opening
                </Button>
            </div>
            <div className="" style={{ paddingTop: "10px" }}>
                <TableListDiv
                    columns={searchColumns}
                    data={vinWiseOpening}
                    Actions={vinWiseOpeningAction}
                    setHeight={parseFloat(heights) - 220}
                    getIndex={3}
                    filterBoxNone={""}
                    rightBox={""}
                    centerBox={""}
                    callHeightFunc={callHeightFunc}
                    paddingShort={2}
                    getWidth={"100%"}
                    actionClass={"actionTdDR"}
                />
            </div>
        </>
    );
};

export default VinWiseOpeningList;
